import React from 'react'
import { TableProps } from 'antd/lib/table'
import moment from 'moment'

import { ColumnProps } from 'src/components/Ant/Table'
import { currencyMask } from 'src/components/Formik'
import { R7Data } from 'src/store/ducks/reports/types'
import { Table, Text, Tooltip } from 'src/components/Ant'

function abbreviate(word: string, index: number) {
  return index
    ? /[A-Z]/.test(word.charAt(0))
      ? `${word.charAt(0)}.`
      : /[0-9]/.test(word.charAt(0))
      ? word
      : null
    : word
}

const columns: ColumnProps<R7Data>[] = [
  {
    align: 'center',
    dataIndex: 'request_number',
    key: 'request_number',
    render: (value: string) => <Text>#{value}</Text>,
    title: 'web.report.7.data.request-number',
    width: 50
  },
  {
    align: 'center',
    dataIndex: 'requested_on',
    key: 'requested_on',
    render: (requested_on: number) => (
      <Text>{moment.unix(requested_on).format('DD/MM/YYYY')}</Text>
    ),
    title: 'web.report.9.data.created-on',
    width: 60
  },
  {
    align: 'center',
    dataIndex: 'e_ticket',
    key: 'e_ticket',
    render: (value: string) => <Text>{value}</Text>,
    title: 'web.report.7.data.e-ticket',
    width: 60
  },
  {
    align: 'center',
    dataIndex: 'traveler',
    ellipsis: true,
    key: 'traveler',
    render: (value: string) => (
      <Tooltip title={<>{value}</>}>
        <Text>{value.split(' ').map(abbreviate).join(' ')}</Text>
      </Tooltip>
    ),
    title: 'web.report.7.data.traveler'
  },
  {
    align: 'center',
    dataIndex: 'checkin_date',
    key: 'checkin_date',
    render: (value: number) => (
      <Text>{moment.unix(value).format('DD/MM/YYYY')}</Text>
    ),
    title: 'web.report.7.data.checkin'
  },
  {
    align: 'center',
    dataIndex: 'checkout_date',
    key: 'checkout_date',
    render: (value: number) => (
      <Text>{moment.unix(value).format('DD/MM/YYYY')}</Text>
    ),
    title: 'web.report.7.data.checkout'
  },
  {
    align: 'center',
    dataIndex: 'daily',
    key: 'daily',
    render: (value: string) => <Text>{value}</Text>,
    title: 'web.report.7.data.daily'
  },
  {
    align: 'center',
    dataIndex: 'city',
    ellipsis: true,
    key: 'city',
    render: (value: string) => <Text>{value}</Text>,
    title: 'web.report.7.data.city'
  },
  {
    align: 'center',
    dataIndex: 'hotel',
    key: 'hotel',
    render: (value: string) => <Text>{value}</Text>,
    title: 'web.report.7.data.hotel_name'
  },
  {
    align: 'center',
    dataIndex: 'agency_name',
    ellipsis: true,
    key: 'agency_name',
    render: (value: string) => <Text>{value}</Text>,
    title: 'web.report.7.data.agency-name'
  },
  {
    align: 'right',
    dataIndex: 'tickets_total_sum',
    key: 'tickets_total_sum',
    render: (value: number) => (
      <Text>
        {
          currencyMask({
            formatStr: true,
            precision: 2,
            value
          }).maskedValue
        }
      </Text>
    ),
    title: 'web.report.7.data.tickets-total-sum'
  }
]

function TableDetail(props: TableProps<R7Data>) {
  return (
    <Table
      {...props}
      className="table-striped table-sm"
      columns={columns}
      pagination={false}
    />
  )
}

export default TableDetail
